// extracted by mini-css-extract-plugin
export default {"pill":"evaluation_pill__hGE1t"};